import { useEffect } from 'react';

interface SchemaOrgProps {
  schema: object;
  id?: string;
}

export default function SchemaOrg({ schema, id = 'schema-org' }: SchemaOrgProps) {
  useEffect(() => {
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, [id]);

  return null;
}
